import { AstraTooltip, astraTwMerge } from '~/astra'
import { ButtonTag } from '~/components'
import { Practitioner, PractitionerStatusDefinition, usePractitionerStatusDefinitions } from '~/storm'

export type StatusDefinitionListProps = {
    assignedStatuses: string[]
    onStatusClick?: (status: PractitionerStatusDefinition) => void
    practitioner?: Practitioner
}

export const StatusDefinitionList = ({ assignedStatuses, onStatusClick, practitioner }: StatusDefinitionListProps) => {
    const statuses = usePractitionerStatusDefinitions({
        where: practitioner?.speciality_uuid ? { specialities: { uuid: practitioner.speciality_uuid } } : undefined,
    })

    const isStatusAssigned = (status: { code: string }) => assignedStatuses.some(assignedStatus => assignedStatus === status.code)

    return (
        <div className="grid grid-cols-3 gap-2">
            {statuses.map(status => (
                <AstraTooltip key={status.code} tooltipContent={status.title}>
                    <ButtonTag
                        className={astraTwMerge('flex h-[20px] min-w-10 items-center', isStatusAssigned(status) ? 'border border-brand-ring' : '')}
                        key={status.code}
                        colorType={status.color}
                        label={status.label}
                        fillType="all"
                        onClick={() => onStatusClick?.(status)}
                    />
                </AstraTooltip>
            ))}
        </div>
    )
}
